export default __webpack_public_path__ + "static/media/homescreen.64f729da.png";